import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-send-email-dialog',
  templateUrl: './send-email-dialog.component.html',
  styleUrls: ['./send-email-dialog.component.scss'],
})
export class SendEmailDialogComponent {
  checkUuid: string;

  emailControl = new FormControl('', [
    Validators.required,
    Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
  ]);

  phoneControl = new FormControl('', [
    Validators.required,
    Validators.pattern('^[0-9]{9,9}$'),
  ]);
  submitted = false;
  loading = false;
  deliveryType: 'email' | 'sms' = 'sms';

  constructor(
    private modalCtrl: ModalController,
    private shared: SharedService
  ) {}

  send() {
    if (this.deliveryType == 'sms') {
      this._sendSms();
    } else {
      this._sendEmail();
    }
  }

  private _sendEmail() {
    this.submitted = true;
    if (this.emailControl.invalid) {
      return;
    }

    this.emailControl.disable();
    this.shared
      .sendEmail({
        email: this.emailControl.value,
        checkUuid: this.checkUuid,
      })
      .subscribe(
        () => {
          this.shared.showSuccessToast('Повідомлення надіслано');
          this.close();
        },
        () => {
          this.emailControl.enable();
          this.shared.showErrorToast('Помилка при відправці');
        }
      );
  }

  private _sendSms() {
    this.submitted = true;
    if (this.phoneControl.invalid) {
      return;
    }

    this.phoneControl.disable();
    const phone = this.phoneControl.value;
    const fullNumber = `+380${phone}`;
    this.shared
      .sendSms({
        phoneNumber: fullNumber,
        checkUuid: this.checkUuid,
      })
      .subscribe(
        () => {
          this.shared.showSuccessToast('Повідомлення надіслано');
          this.close();
        },
        () => {
          this.phoneControl.enable();
          this.shared.showErrorToast('Помилка при відправці');
        }
      );
  }

  updateDeliveryType(deliveryType: 'email' | 'sms') {
    this.deliveryType = deliveryType;
  }

  close() {
    this.modalCtrl.dismiss();
  }
}
